import { FormattedMessage } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { Table } from '~/eds/src/modules/Table/Table';
import { Nullable } from '~/types/Nullable';

import { TableRowValue, TableValue } from '../../types/table';

interface Props {
  tableValue: Nullable<TableValue>;
}

export const TableValueDisplay = ({ tableValue }: Props) => {
  if (!tableValue?.value.length) {
    return (
      <Text>
        <FormattedMessage
          id="Xray.tableValueDisplay.noValue"
          defaultMessage="No value found."
          description="Message when no table values were found."
        />
      </Text>
    );
  }
  const columns = tableValue.spec.columns.map((column, index) => {
    const cellType = mapCellType(column.column_type);
    return {
      key: `${index + 1}-${column.name}`,
      cellType,
      disableSortBy: true,
      title: column.name,
      width: tableValue.spec.columns.length === 1 ? 'auto' : 's',
      mapCellProps: (tableRow: TableRowValue) => {
        return { [cellType]: tableRow.cells[index].value };
      },
    };
  });
  return (
    <Layout direction="column" w="100%">
      <Table
        columns={columns}
        data={tableValue.value}
        name="table-model-values"
        options={{
          enableExportXlsx: false,
          enablePagination: false,
          enableManageColumns: false,
          enableSelectRows: false,
          enableStickyLeft: false,
        }}
        reactTableOptions={{
          manualSortBy: true,
          autoResetHiddenColumns: false,
          autoResetResize: false,
        }}
        state={{ pageSize: tableValue.value.length }}
        totalCount={tableValue.value.length * columns.length}
      />
    </Layout>
  );
};

const mapCellType = (
  type: 'string' | 'text_area' | 'int' | 'float' | 'datetime',
) => {
  switch (type) {
    case 'datetime':
      return 'datetime';
    case 'int':
    case 'float':
      return 'number';
    case 'string':
    case 'text_area':
    default:
      return 'text';
  }
};
